import script from "./VitaMainTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaMainTable.vue?vue&type=script&lang=ts&setup=true"

import "./VitaMainTable.vue?vue&type=style&index=0&id=c80df490&lang=scss"

const __exports__ = script;

export default __exports__